import { Component } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';


@Component({
  selector: 'app-psat-score',
  templateUrl: './psat-score.component.html',
  styleUrls: ['./psat-score.component.scss']
})
export class PsatScoreComponent {

  bsConfig: Partial<BsDatepickerConfig> = Object.assign({}, { containerClass: 'theme-default' });

  constructor(
    public bsModalRef: BsModalRef
  ) {}


  submit(form) {
    //
  }
}
